import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="8" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.8 1.6L1.646 7.86a.8.8 0 00.033 1.054L6.8 14.4" stroke="#22096C" strokeWidth="1.6" strokeLinecap="round" /></svg>;